import { Col } from 'react-bootstrap';
import styled from 'styled-components';
import { mediaBreakpointDown } from 'utils/styledCssHelpers';

export const SSocialMediaLinks = styled.div`
  display: flex;
  justify-content: space-around;
  width: 100%;
  max-width: 200px;
  padding-top: 30px;
  vertical-align: middle;

  ${mediaBreakpointDown(
    'lg',
    `
    padding-top: 0px;
    
  `,
  )};

  ${mediaBreakpointDown(
    'md',
    `
    padding-top: 30px;
    display: inline-flex;
  `,
  )};
`;

export const SCol = styled(Col)`
  a {
    display: block;
    font-size: 16px;
    line-height: 40px;
    text-decoration: none;
  }

  ${mediaBreakpointDown(
    'lg',
    `
    text-align: center;
    margin-bottom: 30px;
    justify-content: center;
  `,
  )};
`;
